import { render, staticRenderFns } from "./VuesticAlert.vue?vue&type=template&id=83922ce8&scoped=true"
import script from "./VuesticAlert.vue?vue&type=script&lang=js"
export * from "./VuesticAlert.vue?vue&type=script&lang=js"
import style0 from "./VuesticAlert.vue?vue&type=style&index=0&id=83922ce8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83922ce8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83922ce8')) {
      api.createRecord('83922ce8', component.options)
    } else {
      api.reload('83922ce8', component.options)
    }
    module.hot.accept("./VuesticAlert.vue?vue&type=template&id=83922ce8&scoped=true", function () {
      api.rerender('83922ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-alert/VuesticAlert.vue"
export default component.exports